export const environment = {
  version: '1.0.0',
  production: true,
  credentialsKey: 'alerta-boby-credentials',
  pathParamsKey: 'lHoQZQGYBFLCvPfpeOsLZSTOKKf3IY/HWtcWnwVLnoo',
  oauthStorageKey: 'lcVmxaI1wVRKszr+T7hXXrsbVK5u947bW8fr0IHxJP4',
  baseUrl: 'http://ec2-23-21-180-116.compute-1.amazonaws.com:2000/alerta-boby-web-api/api',
};
